<form [formGroup]="formGroup">
  <div class="form-wrapper">
    <app-adress-form
      [title]="'WF-HomeOrRegisteredAddress' | translate"
      formGroupName="residentialAddress"
      [address]="residentialAddress"
    ></app-adress-form>
  </div>
  <div class="form-wrapper">
    <div class="form-header">
      <mat-checkbox class="additional-adress-checkbox" formControlName="isMailingAddressEnabled">{{
        'WF-MailingAddressIsDifferentThenHome' | translate
      }}</mat-checkbox>
      @if (isMailingAddressEnabledControl.value) {
        <mat-divider></mat-divider>
      }
    </div>
    @if (isMailingAddressEnabledControl.value) {
      <app-adress-form
        formGroupName="correspondenceAddress"
        [address]="correspondenceAddress"
      ></app-adress-form>
    }
  </div>
  <div class="form-wrapper">
    <div class="form-header">
      <mat-checkbox class="additional-adress-checkbox" formControlName="isRegisterAddressEnabled">{{
        'WF-RegisterAddressIsDifferentThenHome' | translate
      }}</mat-checkbox>
      @if (isRegisterAddressEnabledControl.value) {
        <mat-divider></mat-divider>
      }
    </div>
    @if (isRegisterAddressEnabledControl.value) {
      <app-adress-form formGroupName="registeredAddress" [address]="registeredAddress"></app-adress-form>
    }
  </div>
</form>
